export default {
    init() {
        this.selectCategorySlick();
        this.filterAuctions();
    },

    selectCategorySlick(){
        $('.select-category-slider--slider').slick({
            infinite: true,
            slidesToShow: 4,
            arrows: true,
            responsive: [
                {
                    breakpoint: 950,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 769,
                    settings: {
                        arrows: false,
                        slidesToShow: 4,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        infinitive: false,
                        arrows: false,
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 420,
                    settings: {
                        arrows: false,
                        slidesToShow: 2,
                    }
                },
            ]
        });
    },

    filterAuctions(){
        $('.big-auctions--nav li').on('click',function(){
            let loader = $('.auctions-card--wrap .loader-holder');
            loader.show();
            $('.big-auctions--nav li').removeClass('active');
            $(this).addClass('active');
            setTimeout(function () {
                loader.fadeOut(300);
            }, 1000);
        });
    },

}